/* istanbul ignore file */
import AppWrapper from './AppWrapper';

export default AppWrapper;
